module.exports = __webpack_public_path__ + "img/M5X15内六角螺钉.SLDPRT.0adec710.jpg";